import { render } from "./Procurement.vue?vue&type=template&id=3afa0102"
import script from "./Procurement.vue?vue&type=script&lang=js"
export * from "./Procurement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__